module.exports = __webpack_public_path__ + "static/img/yeswecan0013.cbe0eab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0013.png
// module id = 588
// module chunks = 1